import { FC } from 'react';

import { useTranslation } from 'react-i18next';

import Button from '../button/Button';
import './Skiplink.scss';

const SkipLink: FC = () => {
  const { t } = useTranslation();

  return (
    <Button className="skip-link" href="#main-content">
      {t('SHARED.GENERAL.SKIP_TO_MAIN_CONTENT')}
    </Button>
  );
};

export default SkipLink;
